<div class="legal-status-chip legal-status-chip--{{ legalStatus }}">
  {{ legalStatus === LegalStatus.PARA_PHARMACEUTICAL ? 'PARA' : (legalStatus | uppercase) }}
</div>
